// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"ebb18c35","232":"f5b4f9d6","453":"bdac38e4","465":"93af8b4f","963":"d3dd8747"}[chunkId] + ".chunk.js";
};